document.addEventListener("DOMContentLoaded", function () {
  function updateTableHeights() {
    const els = document.querySelectorAll(".become-sponsor, .attendance-fees, section.table");

    els?.forEach((el) => {
      const tableEls = el.querySelectorAll("table");
      tableEls?.forEach((table) => {
        if (!table) return;

        el.style.setProperty("--table-width", `${table.clientWidth}px`);

        const tableHeight = table.offsetHeight;
        const tableWidth = table.clientWidth - 20;

        const headers = table.querySelectorAll("th");
        const firstTd = table.querySelectorAll("td:nth-of-type(1)");
        const footerTd = table.querySelectorAll("tfoot td");

        headers.forEach((th) => {
          th.style.setProperty("--table-height", `${tableHeight}px`);
        });

        firstTd.forEach((th) => {
          th.style.setProperty("--table-width", `${tableWidth}px`);
        });

          footerTd.forEach((th) => {
              th.style.setProperty("--table-height", `${tableHeight}px`);
          });
      });
    });
  }

  setTimeout(() => {
    updateTableHeights();
  }, 150);
  window.addEventListener("resize", updateTableHeights);

  document.querySelectorAll(".wysiwyg-module table").forEach((table) => {
    const wrapper = document.createElement("div");
    wrapper.classList.add("table-wrapper");
    table.parentNode.insertBefore(wrapper, table);
    wrapper.appendChild(table);
  })
});
